import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const useAssignPlatformOwner = () => {
    return useMutation({
        mutationFn: async (companyId: number) => {
            const url = `/api/organizations/${companyId}/assign_platform_owner`;
            const res = await loggedInApiCall.patch(
                url,
                {},
                { headers: { "Content-Type": "application/merge-patch+json" } },
            );
            return res;
        },
    });
};
